"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputVStack = exports.InputOptionsValueVStack = exports.InputOptionsVStack = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _VerticalStack = _interopRequireDefault(require("../../VerticalStack/index.js"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
const _excluded = ["isFocus", "error", "errorColor", "bg", "success", "successColor", "focusColor", "isHover", "hoverColor", "defaultBorderColor", "defaultTextColor", "disabled", "disablebgColor", "focusStateBorderColor", "errorStateBorderColor", "successStateBorderColor", "disabledStateBorderColor", "borderWidth", "borderStyle", "borderRadius", "boxShadow", "textIndent", "textPadding", "textMargin", "paddingHorizontal", "paddingVertical"];
const InputOptionsVStack = exports.InputOptionsVStack = (0, _styledComponents.default)(_VerticalStack.default)`
	${({
  backgroundColor
}) => `
	border-radius: 0px 0px 12px 12px;
	cursor: pointer;
	padding: 10px;
	background: ${backgroundColor};
	box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.15);
`}
`;
const InputOptionsValueVStack = exports.InputOptionsValueVStack = (0, _styledComponents.default)(_VerticalStack.default)`
	${({
  backgroundColor
}) => `
	cursor: pointer;
	padding: 10px;
	width: 100%;
	margin-bottom: 2px;
	background: ${backgroundColor};
`}
`;
const InputVStack = exports.InputVStack = (0, _styledComponents.default)(_VerticalStack.default)`
	${_ref => {
  let {
      isFocus,
      error,
      errorColor,
      bg,
      success,
      successColor,
      isHover,
      hoverColor,
      defaultBorderColor,
      defaultTextColor,
      disabled,
      disablebgColor,
      focusStateBorderColor,
      errorStateBorderColor,
      successStateBorderColor,
      disabledStateBorderColor,
      borderWidth,
      borderStyle,
      borderRadius,
      boxShadow,
      textPadding = '8px 16px',
      textMargin,
      paddingHorizontal,
      paddingVertical
    } = _ref,
    props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  return `
  border: ${`${borderWidth}px ${borderStyle} ` + (error ? errorStateBorderColor : success ? successStateBorderColor : isFocus ? focusStateBorderColor : isHover ? hoverColor : disabled ? disabledStateBorderColor : defaultBorderColor)};
  border-radius: ${borderRadius};
  justify-content: center;
  position:relative;
  fill: ${error ? errorColor : success ? successColor : defaultTextColor};
  stroke: ${error ? errorColor : success ? successColor : defaultTextColor};
  color: ${error ? errorColor : success ? successColor : defaultTextColor};
  background: ${disabled ? disablebgColor : bg};
  ${boxShadow};
  padding: ${textPadding ? textPadding : paddingHorizontal || paddingVertical ? `${paddingVertical ?? 0}px ${paddingHorizontal ?? 0}px` : '8px 16px'};
  margin:${textMargin};
  ${disabled !== undefined && 'cursor: ' + (disabled ? 'initial' : 'text') + ';'}
  
  & input::-webkit-outer-spin-button,
  & input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  
  & input[type=number] {
    -moz-appearance: textfield;
  }

`;
}}
`;